interface ModuleHeadingProps {
  children: React.ReactNode;
  secondaryContent?: React.ReactNode;
}

export const ModuleHeading = ({
  children,
  secondaryContent,
}: ModuleHeadingProps) => {
  return (
    <div className="flex items-center justify-between text-xs font-medium">
      <h2 className="uppercase tracking-wider text-zinc-600">{children}</h2>

      {secondaryContent && <div>{secondaryContent}</div>}
    </div>
  );
};
